import Axios from "axios"
import { errorHandler } from "../../utils"
import api from "../../api"
import auth from "../../utils/auth"
import { TIMEOUT } from "../../constants"
const { getTokenFromLocalStorage } = auth()

const occupationService = {
  async getAll(){
    const token = getTokenFromLocalStorage()
    const config = {
      timeout: TIMEOUT,
      headers: {
        'X-Api-Key': api.key,
        'Authorization': `JWT ${token}`
      }
    }

    return new Promise(function(resolve, reject){
      Axios.get(api.base+api.occupation, config)
        .then(res => {
          if(res.data.results){
            resolve(res.data.results)
          }
          else if(res.data){
            resolve(res.data)
          }
          else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
    })
  },
}

export default occupationService
